import React from 'react';
import { useSelector } from 'react-redux';
import type { SerializedStyles } from '@emotion/react';
import AdSlot from '@gumtree/third-party-ads/display-ad-slot';
import buildSlotConfig from '@gumtree/third-party-ads/src/framework/dfp/ad-config/build-slot-config';
import type { SlotName } from '@gumtree/third-party-ads/src/framework/dfp/ad-config/slot-configs';
import type { VipState } from '../reducers';
import { selectState, selectPartnershipParams } from '../selectors';
import { useShouldShowGAMPartnershipAds } from '../hooks';

export const renderAdSlot = (
    slotName: SlotName,
    l1Category: VipState['adDetails']['l1CategorySeoName'] = 'toplevel',
    device: VipState['baseConfig']['device']['type'],
    css?: SerializedStyles
) => {
    const showSlot = buildSlotConfig({
        resultSize: 0,
        l1Category,
        device,
        pageType: 'VIP',
    })
        .map((_) => _?.divId)
        .includes(slotName);

    return showSlot ? <AdSlot id={slotName} css={css} /> : <></>;
};

    
export interface PartnershipAdFlags {
    isPartnerAdCompact1Gam: boolean;
    isPartnerAdCompact2Gam: boolean;
    isPartnerAdDefault1Gam: boolean;
}
    
export function usePartnershipAdFlags(): PartnershipAdFlags {
    const { baseConfig } = useSelector(selectState);
    const partnershipParams = useSelector(selectPartnershipParams);
    const { device, bffUrl, canonicalUrl } = baseConfig;
    const { l1Category, l2Category, l3Category } = partnershipParams;

    const isPartnerAdCompact1Gam = useShouldShowGAMPartnershipAds(
        'partnerAdCompact1',
        device.type,
        l1Category,
        l2Category,
        l3Category,
        bffUrl,
        canonicalUrl
    );

    const isPartnerAdCompact2Gam = useShouldShowGAMPartnershipAds(
        'partnerAdCompact2',
        device.type,
        l1Category,
        l2Category,
        l3Category,
        bffUrl,
        canonicalUrl
    );

    const isPartnerAdDefault1Gam = useShouldShowGAMPartnershipAds(
        'partnerAdDefault1',
        device.type,
        l1Category,
        l2Category,
        l3Category,
        bffUrl,
        canonicalUrl
    );

    return {
        isPartnerAdCompact1Gam,
        isPartnerAdCompact2Gam,
        isPartnerAdDefault1Gam,
    };
}
